/* eslint-disable import/no-extraneous-dependencies */
import Vue from 'vue';
import Cleave from 'vue-cleave-component';

require('cleave.js/dist/addons/cleave-phone.cy');

Vue.use(Cleave);
